import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from 'common/components/Box';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Button from 'common/components/Button';
import Input from 'common/components/Input';
import Container from 'common/components/UI/Container';
import NewsletterWrapper, { ContactFormWrapper } from './newsletter.style';
import moment from 'moment';
import toast, { Toaster } from 'react-hot-toast';

const Newsletter = ({
  sectionWrapper,
  textArea,
  buttonArea,
  buttonStyle,
  title,
  description,
}) => {
  const [value, setValue] = useState('');

  const handleQueryChange = (event) => {
    console.log('event.target.value', event);
    setValue(event);
  };

  const Airtable = require('airtable');
  const base = new Airtable({
    apiKey: process.env.GATSBY_API_KEY_AIRTABLE,
  }).base(process.env.GATSBY_BASE_ID);

  const handleSubmitEmail = () => {
    base('EmailsLanding').create(
      { email: value, received_at: moment().toISOString() },
      function (err, records) {
        if (err) {
          console.error(err);
          toast.error('Ocurrió un error', {
            duration: 4000,
            position: 'bottom-right',
          });

          return;
        }

        toast.success('Correo envíado', {
          duration: 4000,
          position: 'bottom-right',
        });
      }
    );
  };

  return (
    <Box {...sectionWrapper} id="contactame">
      <NewsletterWrapper>
        <Container>
          <Box {...textArea}>
            <Heading content="¿Deseas tener una demostración?" {...title} />
            <Text
              content="Déjanos tu correo y te contactaremos lo más pronto posible."
              {...description}
            />
          </Box>
          <Box {...buttonArea}>
            <ContactFormWrapper>
              <Input
                inputType="email"
                label="Correo Electrónico"
                iconPosition="right"
                isMaterial={true}
                className="email_input"
                value={String(value)}
                onChange={handleQueryChange}
              />
              <Button
                {...buttonStyle}
                title="Enviar"
                onClick={handleSubmitEmail}
              />
            </ContactFormWrapper>
          </Box>
          <Toaster />
        </Container>
      </NewsletterWrapper>
    </Box>
  );
};

Newsletter.propTypes = {
  sectionWrapper: PropTypes.object,
  textArea: PropTypes.object,
  buttonArea: PropTypes.object,
  buttonStyle: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
};

Newsletter.defaultProps = {
  sectionWrapper: {},
  textArea: {
    mb: ['40px', '40px', '40px', '0', '0'],
    pr: ['0', '0', '0', '80px', '100px'],
  },
  title: {
    fontSize: ['18px', '20px', '22px', '24px', '26px'],
    fontWeight: '500',
    color: '#fff',
    lineHeight: '1.34',
    mb: ['14px', '14px', '14px', '14px', '13px'],
    textAlign: ['center', 'center', 'center', 'left', 'left'],
    letterSpacing: '-0.025em',
  },
  description: {
    fontSize: ['14px', '14px'],
    maxWidth: ['100%', '400px'],
    fontWeight: '400',
    color: '#fefefe',
    lineHeight: '1.7',
    mb: 0,
    textAlign: ['center', 'center', 'center', 'left', 'left'],
  },
  buttonArea: {
    zIndex: 1,
  },
  buttonStyle: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '700',
    pl: '30px',
    pr: '30px',
  },
};

export default Newsletter;
